/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Chart_MetricInputs */



/**
* | output |
* | --- |
* | "Chart Metric" |
*
* @param {Usage_Chart_MetricInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_chart_metric = /** @type {((inputs?: Usage_Chart_MetricInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Chart_MetricInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Indicateur graphique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diagrammmetrik")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metrica del grafico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метрика диаграммы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Métrica del gráfico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("图表指标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チャートメトリック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चार्ट मीट्रिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Métrica do gráfico")
	return /** @type {LocalizedString} */ ("Chart Metric")
});